import type Enums from '../types/api/Enums';

export enum ActivitySchedulerViews {
  Agenda = 'agenda',
  Day = 'day',
  Month = 'month',
  Week = 'week',
}

export enum ActivitiesFilter {
  All = 'all',
  Assigned = 'assigned',
  Created = 'created',
  Active = 'active',
  Overdue = 'overdue',
}

export enum ActivityCategoryFilter {
  All = 'all',
  Email = 'Email',
  SiteVisit = 'Site Visit',
  Call = 'Call',
  SalesVisit = 'Sales Visit',
  Other = 'Other',
  Task = 'Task',
}

export enum DateFilter {
  Today = 'today',
  Yesterday = 'yesterday',
  Last7Days = 'last7Days',
  Last14Days = 'last14Days',
  Last30Days = 'last30Days',
  ThisWeek = 'thisWeek',
  ThisMonth = 'thisMonth',
  LastMonth = 'lastMonth',
  AllTime = 'all',
}

export type ActivityFilters = {
  searchText: string;
  activitiesFilter: ActivitiesFilter;
  categoryFilters: ActivityCategoryFilter;
  userID: string;
  marketIDs: string[];
  divisionIDs: string[];
  plantIDs: string[];
  dateFilters: DateFilter;
  status: Enums.ActivityStatus | null;
};

export type AdditionalActivityFilters = {
  projectId?: string;
  companyId?: string;
  contactId?: string;
};
